import shoppableImage from '../helpers/ShoppableImage';
import button from '../helpers/Button';

let module_name = '';
let index = '';
const generateContent = (content, _button) => {
  const html = `
  <div class="Module-SplitContent__Block Module-SplitContent__Block--Content">
    ${content}
    ${button([_button], module_name, index)}
  </div>`;
  return html;
};

export default (settings, name, i) => {
  module_name = name;
  index = i;

  const content_html = `
  <div class="Module-SplitContent__Inner">
    <div class="Module-SplitContent__Columns">
      <div class="Module-SplitContent__Column Module-SplitContent__Left">
        <div class="Module-SplitContent__Column-Inner Module-SplitContent__Left-inner">
          ${
            settings.order === 'standard'
              ? generateContent(settings.content, settings.button)
              : shoppableImage(settings.image)
          }
        </div>
      </div>
      <div class="Module-SplitContent__Column Module-SplitContent__Right">
        <div class="Module-SplitContent__Column-Inner Module-SplitContent__Right-inner">
          ${
            settings.order === 'standard'
              ? shoppableImage(settings.image)
              : generateContent(settings.content, settings.button)
          }
          </div>
      </div>
    </div>
  </div>
  `;
  return content_html;
};
